import { pluginFactory } from 'bootstrap-vue/src/utils/plugins';

export { installFactory } from 'bootstrap-vue/src/utils/plugins';

import {
  ModalPlugin,
  LayoutPlugin,
  LinkPlugin,
  FormPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  ButtonPlugin,
  FormTextareaPlugin,
  SpinnerPlugin,
  ImagePlugin,
  NavbarPlugin,
  FormCheckboxPlugin,
  CardPlugin,
  VBTooltipPlugin,
  AlertPlugin,
  PopoverPlugin,
} from 'bootstrap-vue';

export const componentsPlugin = pluginFactory({
  plugins: {
    ModalPlugin,
    LayoutPlugin,
    LinkPlugin,
    FormPlugin,
    FormGroupPlugin,
    FormInputPlugin,
    FormRadioPlugin,
    FormSelectPlugin,
    ButtonPlugin,
    FormTextareaPlugin,
    SpinnerPlugin,
    ImagePlugin,
    NavbarPlugin,
    FormCheckboxPlugin,
    CardPlugin,
    VBTooltipPlugin,
    AlertPlugin,
    PopoverPlugin,
  },
});
